const doc = [({"no":({"js":({"routes":({"play":({"welcome":({"enter_code_to_begin":"Skriv inn koden for å begynne"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;